import { withErrorBoundary } from 'react-error-boundary';
import { useIsPreview } from 'components/pages/Contentful/context/PreviewContext';
import ArticleCard from '../components/ArticleCard';
import BrandSlider from '../components/BrandSlider';
import Button from '../components/Button';
import Carousel from '../components/ContentCarousel';
import CustomScriptBlock from '../components/CustomScriptBlock';
import ImageBanner from '../components/Image';
import InlineLink from '../components/InlineLink';
import LayoutRenderer from '../components/Layout/LayoutRenderer';
import Position from '../components/Position';
import ProductCard from '../components/ProductCard';
import ProductRecommendation from '../components/ProductRecommendation';
import Shortcuts from '../components/Shortcuts';
import Text from '../components/Text';
import TextStyle from '../components/TextStyle';
import UserSegmentation from '../components/UserSegmentation';
import Video from '../components/Video';

function ComponentRenderer(data) {
    const isPreview = useIsPreview();

    try {
        if (!data?.fields?.isPublished && !isPreview.isPreviewMode) return null;

        switch (data?.sys?.contentType?.sys?.id) {
            case 'layout':
                return <LayoutRenderer {...data} />;
            case 'text':
                return <Text {...data} />;
            case 'position':
                return <Position {...data} />;
            case 'imageBanner':
                return <ImageBanner {...data} />;
            case 'userSegmentation':
                return <UserSegmentation {...data} />;
            case 'productCard':
                return <ProductCard {...data} />;
            case 'video':
                return <Video {...data} />;
            case 'carousel':
                return <Carousel {...data} />;
            case 'brandSlider':
                return <BrandSlider {...data} />;
            case 'textStyle':
                return <TextStyle {...data} />;
            case 'button':
                return <Button {...data} />;
            case 'inlineLink':
                return <InlineLink {...data} />;
            case 'shortcuts':
                return <Shortcuts {...data} />;
            case 'productRecommendation':
                return <ProductRecommendation {...data} />;
            case 'articleCard':
                return <ArticleCard {...data} />;
            case 'customScriptBlock':
                return <CustomScriptBlock {...data} />;
            default:
                throw new Error(`"${data?.sys?.contentType?.sys?.id}" is not recognized`);
        }
    } catch (e) {
        console.error(e);
        return null;
    }
}

export default withErrorBoundary(ComponentRenderer, {
    fallback: null,
    onError(error, info) {
        console.error(error, info);
    }
});
